export default function buyCertificationLink(productId) {
  return `${process.env.NEXT_PUBLIC_STORE_HOST}/certificacion/carrito?producto=${productId}`;
}
